// LengthUnitSuffix.js
import React from 'react';
import { InputSuffix } from '@progress/kendo-react-inputs';

// Kendo renders `suffix` as a component type, so each unit gets one stable component:
// an inline arrow function would be a new type every render and remount the suffix.
const suffixes = {};

/** The unit shown at the end of a length input ("in", "mm" ...) instead of inside its formatted text. */
export function lengthUnitSuffix(unit) {
    if (!suffixes[unit]) {
        const Suffix = () => <InputSuffix className="accent-length-unit" aria-hidden="true">{unit}</InputSuffix>;
        Suffix.displayName = `LengthUnitSuffix(${unit})`;
        suffixes[unit] = Suffix;
    }
    return suffixes[unit];
}

/** The "+" between the whole inches and the fraction of an imperial length. */
export const LengthPlus = () => <div className="accent-length-plus" aria-hidden="true">+</div>;
